import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface GetGeoWishesFromCandidateResponse extends BackendResponse {
  counties: GeoWish[];
  municipalities: GeoWish[];
}

export const getGeoWishes = withNextApi<GetGeoWishesFromCandidateResponse>(
  "/cvp/CvpGetGeoWishesFromCandidate",
  { method: "GET" }
);

export interface GeoWish {
  id: number;
  navn: string;
  id_typer: number;
  id_fylker?: number;
}
